var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.4722,
    cy: 32.9351,
    r: 32.0171,
    fill: "#EEF0F2",
    stroke: "white",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_6074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4726 9.89453C26.2956 9.89453 21.2416 15.1057 21.2416 21.5265C21.2416 27.9474 26.2956 33.1586 32.4726 33.1586C38.6496 33.1586 43.7035 27.9474 43.7035 21.5265C43.7035 15.1057 38.6496 9.89453 32.4726 9.89453ZM20.7363 33.1586C14.7839 33.3912 10.0107 37.4391 10.0107 42.4642V47.117H54.9344V42.4642C54.9344 37.4391 50.2174 33.3912 44.2089 33.1586C41.1765 35.9968 37.0211 37.8114 32.4726 37.8114C27.924 37.8114 23.7686 35.9968 20.7363 33.1586Z",
    fill: "#8D8D8D",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_6074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.9236,
    height: 37.2224,
    fill: "white",
    transform: "translate(10.0107 9.89453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default_profile.90e283b0007a871c3f3caab96a3ec460.svg";
export { ForwardRef as ReactComponent };